const footerDict = {
  CONTACT_ME: "Contact me",
  CONTACT_MESSAGE: "Contact me to start a collaboration together",
  MILAN: "Milan",
  ITALY: "Italy",
  BYE: "Bye bye!",
};
export default footerDict;
